import React, { useRef, useState, useEffect } from "react";
import Sidebar from "../../components/Structure/Sidebar";
import HoldOn from 'react-hold-on';
import { useDispatch, useSelector } from "react-redux";
import { getBenificiaryListByStudentId, BeneficiaryCreates } from "../../@redux/Action/Beneficary";
import { FaPlus, FaSearch, FaChevronLeft, FaChevronRight, FaTimes } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { MenuItem, TextField, Button, Modal, Box } from "@mui/material";
import { CustomTextField } from "../../utils/Fields";

const currencyOptions = [
    { value: "USD", label: "USD" },
    { value: "AUD", label: "AUD" },
    { value: "SGD", label: "SGD" },
    { value: "CAD", label: "CAD" },
    { value: "GBP", label: "GBP" },
    { value: "EURO", label: "EURO" },
];

const initialBeneficiaryState = {
    name: "",
    email: "",
    phone: "",
    accountNumber: "",
    iban: "",
    swiftCode: "",
    sortCode: "",
    country: "",
    streetAddress: "",
    currency: "",
};

function BeneficiaryPage({studentId}) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [beneficiaryData, setBeneficiaryData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState("");
    const beneficiariesPerPage = 10;
    const [openModal, setOpenModal] = useState(false);
    const [openDetailsModal, setOpenDetailsModal] = useState(false);
    const [selectedBeneficiary, setSelectedBeneficiary] = useState(null);
    const [beneficiaryDetails, setBeneficiaryDetails] = useState(initialBeneficiaryState);

    const handleModalOpen = () => setOpenModal(true);
    const handleModalClose = () => {
        setBeneficiaryDetails(initialBeneficiaryState);
        setOpenModal(false);
    };

    const handleDetailsModalOpen = (beneficiary) => {
        setSelectedBeneficiary(beneficiary);
        setOpenDetailsModal(true);
    };

    const handleDetailsModalClose = () => {
        setSelectedBeneficiary(null);
        setOpenDetailsModal(false);
    };
    console.log("selectedBeneficiary",selectedBeneficiary);

    const handleSearch = (value) => {
        setSearchTerm(value);
        setCurrentPage(1); // Reset to first page when searching
    };

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '80%',
        maxWidth: 800,
        bgcolor: 'background.paper',
        boxShadow: 24,
        maxHeight: '90vh',
        overflow: 'auto',
        borderRadius: '12px',
        border: 'none'
    };

    const handleInputChange = (e, field) => {
        setBeneficiaryDetails({ ...beneficiaryDetails, [field]: e.target.value });
    };

    const handleAddBeneficiary = async () => {
        if (!beneficiaryDetails.name || !beneficiaryDetails.email || !beneficiaryDetails.phone || !beneficiaryDetails.accountNumber || !beneficiaryDetails.currency) {
            alert("Please fill in all required fields");
            return;
        }
        try {
            await dispatch(BeneficiaryCreates(beneficiaryDetails,studentId));
            handleModalClose();
            await fetchBeneficiaryData(studentId);
        } catch (error) {
            console.error("Error adding beneficiary:", error);
        }
    };

    const fetchBeneficiaryData = async (studentId) => {
        try {
            const data = await dispatch(getBenificiaryListByStudentId(studentId));
            console.log("Beneficiary data from API:", data);
            if (Array.isArray(data)) {
                setBeneficiaryData(data);
            } else if (data && typeof data === 'object') {
                setBeneficiaryData([data]);
            } else {
                setBeneficiaryData([]);
            }
        } catch (error) {
            console.error("Error fetching beneficiary data:", error);
            setBeneficiaryData([]);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchBeneficiaryData(studentId);
    }, [dispatch, studentId]);

    const filteredBeneficiaries = beneficiaryData.filter(beneficiary =>
        beneficiary?.name?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const indexOfLastBeneficiary = currentPage * beneficiariesPerPage;
    const indexOfFirstBeneficiary = indexOfLastBeneficiary - beneficiariesPerPage;
    const currentBeneficiaries = Array.isArray(filteredBeneficiaries) ? 
        filteredBeneficiaries.slice(indexOfFirstBeneficiary, indexOfLastBeneficiary) : [];

    console.log("Current beneficiaries:", currentBeneficiaries);    

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const totalPages = Array.isArray(filteredBeneficiaries) ? 
        Math.ceil(filteredBeneficiaries.length / beneficiariesPerPage) : 0;

    return (
        <div className="d-md-flex" style={{ height: "100vh", backgroundColor: "#f8f9fa" }}>
            <Sidebar />

            <div className="col-12 col-md-9 px-4 rounded-4 d-flex flex-column overflow-hidden">
                <div className="my-4 mx-auto w-100 d-flex flex-column h-100">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h2 className="mb-0 text-success">Beneficiaries</h2>
                        <button className="btn btn-success d-flex align-items-center" onClick={handleModalOpen}>
                            <FaPlus className="me-2" /> Add Beneficiary
                        </button>
                    </div>

                    <Modal
                        open={openModal}
                        onClose={handleModalClose}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <Box sx={modalStyle} className="p-0">
                            <div className="modal-header bg-success text-white p-4 position-relative">
                                <h4 className="mb-0">Add New Beneficiary</h4>
                                <FaTimes 
                                    className="position-absolute" 
                                    style={{top: '20px', right: '20px', cursor: 'pointer'}}
                                    onClick={handleModalClose}
                                />
                            </div>
                            <div className="modal-body p-4">
                                <div className="my-auto">
                                    <div className="roboto-medium d-flex flex-column h-100">
                                        <div className="flex-grow-1 d-flex flex-column">
                                            <div className="d-flex flex-column justify-content-between">
                                                <div className="mb-3">
                                                    <CustomTextField
                                                        label="University Name"
                                                        value={beneficiaryDetails.name}
                                                        onChange={(e) => handleInputChange(e, "name")}
                                                        fullWidth
                                                        variant="outlined"
                                                        placeholder="Enter University Name"
                                                        required
                                                    />
                                                </div>

                                                <div className="d-flex justify-content-between gap-3 mb-3">
                                                    <div className="form-group w-50">
                                                        <CustomTextField
                                                            label="Beneficiary Email"
                                                            type="email"
                                                            fullWidth
                                                            variant="outlined"
                                                            placeholder="Beneficiary Email"
                                                            value={beneficiaryDetails.email}
                                                            onChange={(e) => handleInputChange(e, "email")}
                                                            required
                                                        />
                                                    </div>
                                                    <div className="form-group w-50">
                                                        <CustomTextField
                                                            label="Phone"
                                                            type="tel"
                                                            fullWidth
                                                            variant="outlined"
                                                            placeholder="Phone Number"
                                                            value={beneficiaryDetails.phone}
                                                            onChange={(e) => handleInputChange(e, "phone")}
                                                            required
                                                        />
                                                    </div>
                                                </div>

                                                <div className="d-flex justify-content-between gap-3 mb-3">
                                                    <div className="form-group w-50">
                                                        <CustomTextField
                                                            label="IBAN"
                                                            type="text"
                                                            fullWidth
                                                            variant="outlined"
                                                            placeholder="IBAN Number"
                                                            value={beneficiaryDetails.iban}
                                                            onChange={(e) => handleInputChange(e, "iban")}
                                                        />
                                                    </div>
                                                    <div className="form-group w-50">
                                                        <CustomTextField
                                                            label="SWIFT Code/BIC"
                                                            type="text"
                                                            fullWidth
                                                            variant="outlined"
                                                            placeholder="SWIFT Code"
                                                            value={beneficiaryDetails.swiftCode}
                                                            onChange={(e) => handleInputChange(e, "swiftCode")}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="d-flex justify-content-between gap-3 mb-3">
                                                    <div className="form-group w-50">
                                                        <CustomTextField
                                                            label="Sort Code"
                                                            type="text"
                                                            fullWidth
                                                            variant="outlined"
                                                            placeholder="Sort Code"
                                                            value={beneficiaryDetails.sortCode}
                                                            onChange={(e) => handleInputChange(e, "sortCode")}
                                                        />
                                                    </div>
                                                    <div className="form-group w-50">
                                                        <CustomTextField
                                                            label="Account number"
                                                            type="text"
                                                            fullWidth
                                                            variant="outlined"
                                                            placeholder="Enter Your Account Number"
                                                            value={beneficiaryDetails.accountNumber}
                                                            onChange={(e) => handleInputChange(e, "accountNumber")}
                                                            required
                                                        />
                                                    </div>
                                                </div>

                                                <div className="d-flex justify-content-between gap-3 mb-3">
                                                    <div className="form-group w-50">
                                                        <CustomTextField
                                                            label="Country"
                                                            type="text"
                                                            fullWidth
                                                            variant="outlined"
                                                            placeholder="Country"
                                                            value={beneficiaryDetails.country}
                                                            onChange={(e) => handleInputChange(e, "country")}
                                                        />
                                                    </div>
                                                    <div className="form-group w-50">
                                                        <CustomTextField
                                                            label="Street Address"
                                                            type="text"
                                                            fullWidth
                                                            variant="outlined"
                                                            placeholder="Street Address"
                                                            value={beneficiaryDetails.streetAddress}
                                                            onChange={(e) => handleInputChange(e, "streetAddress")}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="d-flex justify-content-between gap-3 mb-3">
                                                    <div className="form-group w-50">
                                                        <CustomTextField
                                                            label="Currency"
                                                            select
                                                            fullWidth
                                                            variant="outlined"
                                                            value={beneficiaryDetails.currency}
                                                            onChange={(e) => handleInputChange(e, "currency")}
                                                            required
                                                        >
                                                            {currencyOptions.map((option) => (
                                                                <MenuItem key={option.value} value={option.value}>
                                                                    {option.label}
                                                                </MenuItem>
                                                            ))}
                                                        </CustomTextField>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer bg-light p-3">
                                <button className="btn btn-success" onClick={handleAddBeneficiary}>
                                    Save
                                </button>
                            </div>
                        </Box>
                    </Modal>

                    <Modal
                        open={openDetailsModal}
                        onClose={handleDetailsModalClose}
                        aria-labelledby="details-modal-title"
                        aria-describedby="details-modal-description"
                    >
                        <Box sx={modalStyle} className="p-0">
                            <div className="modal-header bg-success text-white p-4 position-relative">
                                <h4 className="mb-0">Beneficiary Details</h4>
                                <FaTimes 
                                    className="position-absolute" 
                                    style={{top: '20px', right: '20px', cursor: 'pointer'}}
                                    onClick={handleDetailsModalClose}
                                />
                            </div>

                            {selectedBeneficiary && (
                                <>
                                    <div className="modal-body p-4">
                                        <div className="my-auto">
                                            <div className="roboto-medium d-flex flex-column h-100">
                                                <div className="flex-grow-1 d-flex flex-column">
                                                    <div className="d-flex flex-column justify-content-between">
                                                        <div className="mb-3">
                                                            <CustomTextField
                                                                label="University Name"
                                                                value={selectedBeneficiary.name}
                                                                fullWidth
                                                                variant="outlined"
                                                                InputProps={{
                                                                    readOnly: true,
                                                                    style: { backgroundColor: '#fff' }
                                                                }}
                                                            />
                                                        </div>

                                                        <div className="d-flex justify-content-between gap-3 mb-3">
                                                            <div className="form-group w-50">
                                                                <CustomTextField
                                                                    label="Email"
                                                                    value={selectedBeneficiary.email}
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    InputProps={{
                                                                        readOnly: true,
                                                                        style: { backgroundColor: '#fff' }
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="form-group w-50">
                                                                <CustomTextField
                                                                    label="Phone"
                                                                    value={selectedBeneficiary.phone}
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    InputProps={{
                                                                        readOnly: true,
                                                                        style: { backgroundColor: '#fff' }
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="d-flex justify-content-between gap-3 mb-3">
                                                            <div className="form-group w-50">
                                                                <CustomTextField
                                                                    label="IBAN"
                                                                    value={selectedBeneficiary.iban}
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    InputProps={{
                                                                        readOnly: true,
                                                                        style: { backgroundColor: '#fff' }
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="form-group w-50">
                                                                <CustomTextField
                                                                    label="SWIFT Code"
                                                                    value={selectedBeneficiary.swiftCode}
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    InputProps={{
                                                                        readOnly: true,
                                                                        style: { backgroundColor: '#fff' }
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="d-flex justify-content-between gap-3 mb-3">
                                                            <div className="form-group w-50">
                                                                <CustomTextField
                                                                    label="Sort Code"
                                                                    value={selectedBeneficiary.sortCode}
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    InputProps={{
                                                                        readOnly: true,
                                                                        style: { backgroundColor: '#fff' }
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="form-group w-50">
                                                                <CustomTextField
                                                                    label="Account Number"
                                                                    value={selectedBeneficiary.accountNumber}
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    InputProps={{
                                                                        readOnly: true,
                                                                        style: { backgroundColor: '#fff' }
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="d-flex justify-content-between gap-3 mb-3">
                                                            <div className="form-group w-50">
                                                                <CustomTextField
                                                                    label="Country"
                                                                    value={selectedBeneficiary.country}
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    InputProps={{
                                                                        readOnly: true,
                                                                        style: { backgroundColor: '#fff' }
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="form-group w-50">
                                                                <CustomTextField
                                                                    label="Street Address"
                                                                    value={selectedBeneficiary.streetAddress}
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    InputProps={{
                                                                        readOnly: true,
                                                                        style: { backgroundColor: '#fff' }
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="d-flex justify-content-between gap-3 mb-3">
                                                            <div className="form-group w-50">
                                                                <CustomTextField
                                                                    label="Currency"
                                                                    value={selectedBeneficiary.currency}
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    InputProps={{
                                                                        readOnly: true,
                                                                        style: { backgroundColor: '#fff' }
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="form-group w-50">
                                                                <CustomTextField
                                                                    label="Status"
                                                                    value={selectedBeneficiary.status}
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    InputProps={{
                                                                        readOnly: true,
                                                                        style: { backgroundColor: '#fff' }
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="d-flex justify-content-between gap-3 mb-3">
                                                            <div className="form-group w-50">
                                                                <CustomTextField
                                                                    label="Status Remarks"
                                                                    value={selectedBeneficiary.statusRemarks || 'Not Specified'}
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    InputProps={{
                                                                        readOnly: true,
                                                                        style: { backgroundColor: '#fff' }
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="form-group w-50">
                                                                <CustomTextField
                                                                    label="Beneficiary ID"
                                                                    value={selectedBeneficiary.beneficiaryId}
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    InputProps={{
                                                                        readOnly: true,
                                                                        style: { backgroundColor: '#fff' }
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                        </Box>
                    </Modal>

                    <div className="mb-3 position-relative">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search beneficiaries by name..."
                            value={searchTerm}
                            onChange={(e) => handleSearch(e.target.value)}
                        />
                        <FaSearch className="position-absolute top-50 end-0 translate-middle-y me-3 text-muted" />
                    </div>
                    {isLoading ? (
                        <div className="d-flex justify-content-center align-items-center h-100">
                            <div className="spinner-border text-success" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : beneficiaryData?.length > 0 ? (
                        <div className="table-responsive flex-grow-1 bg-white rounded shadow-sm" style={{ fontSize: '0.9rem' }}>
                            <table className="table table-hover mb-0">
                                <thead className="bg-light">
                                    <tr>
                                        <th className="text-success fw-bold py-3 px-3">University</th>
                                        <th className="text-success fw-bold py-3 px-3">Email</th>
                                        <th className="text-success fw-bold py-3 px-3">Phone</th>
                                        <th className="text-success fw-bold py-3 px-3">Country</th>
                                        <th className="text-success fw-bold py-3 px-3">Status</th>
                                        <th className="text-success fw-bold py-3 px-3">Currency</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentBeneficiaries?.map((beneficiary, index) => (
                                        <tr 
                                            key={index} 
                                            className="align-middle cursor-pointer" 
                                            onClick={() => handleDetailsModalOpen(beneficiary)}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <td className="py-2 px-3">{beneficiary?.name}</td>
                                            <td className="py-2 px-3">{beneficiary?.email}</td>
                                            <td className="py-2 px-3">{beneficiary?.phone}</td>
                                            <td className="py-2 px-3">{beneficiary?.country}</td>
                                            <td className="py-2 px-3">
                                                <span
                                                    className={`badge ${
                                                        beneficiary?.status === "Active"
                                                            ? "bg-success"
                                                            : "bg-warning"
                                                    }`}
                                                >
                                                    {beneficiary?.status}
                                                </span>
                                            </td>
                                            <td className="py-2 px-3">{beneficiary?.currency}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div className="alert alert-info" role="alert">
                            No Beneficiary data available.
                        </div>
                    )}
                    <nav className="mt-4">
                        <ul className="pagination justify-content-center">
                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                <button className="page-link text-success" onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
                                    <FaChevronLeft />
                                </button>
                            </li>
                            {totalPages <= 5 ? (
                                [...Array(totalPages)].map((_, i) => (
                                    <li key={i} className={`page-item ${currentPage === i + 1 ? 'active' : ''}`}>
                                        <button className={`page-link ${currentPage === i + 1 ? 'bg-success text-white' : 'text-success'}`} onClick={() => paginate(i + 1)}>{i + 1}</button>
                                    </li>
                                ))
                            ) : (
                                <>
                                    {currentPage > 2 && (
                                        <>
                                            <li className="page-item"><button className="page-link text-success" onClick={() => paginate(1)}>1</button></li>
                                            {currentPage > 3 && <li className="page-item disabled"><span className="page-link text-success">...</span></li>}
                                        </>
                                    )}
                                    {[...Array(5)].map((_, i) => {
                                        const pageNum = currentPage + i - 2;
                                        return pageNum > 0 && pageNum <= totalPages ? (
                                            <li key={i} className={`page-item ${currentPage === pageNum ? 'active' : ''}`}>
                                                <button className={`page-link ${currentPage === pageNum ? 'bg-success text-white' : 'text-success'}`} onClick={() => paginate(pageNum)}>{pageNum}</button>
                                            </li>
                                        ) : null;
                                    })}
                                    {currentPage < totalPages - 1 && (
                                        <>
                                            {currentPage < totalPages - 2 && <li className="page-item disabled"><span className="page-link text-success">...</span></li>}
                                            <li className="page-item"><button className="page-link text-success" onClick={() => paginate(totalPages)}>{totalPages}</button></li>
                                        </>
                                    )}
                                </>
                            )}
                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                <button className="page-link text-success" onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>
                                    <FaChevronRight />
                                </button>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    );
}

export default BeneficiaryPage;